import React from "react";
import "../css/AcInstallation.css";
import Topbar from "../components/Topbar";
import Header from "../components/header";
import Footer from "../screen/Footer"; 
import Herolast  from "../screen/herolast";

export default function AcInstallation() {
  return (
    <>
       <Topbar/>
      <Header />
      {/* Hero (your original card) */}
      <section className="ac-hero">
        <div className="ac-hero-bg" />

        <div className="ac-hero-card">
          <p className="ac-hero-kicker">Cool Comfort</p>

          <h1 className="ac-hero-title">
            Expert AC Installation Services
            <br />
           for Your Home
          </h1>

          <p className="ac-hero-subtitle">
            Get all kinds of AC service at your doorstep in 30 minutes. Schedule
            your service now!
          </p>

          <a className="ac-hero-cta" href="tel:7237898275">
            7237898275
          </a>
        </div>
      </section>

        {/* === New content section: two-column layout like screenshots === */}
      <section className="ac-article-section">
        <div className="container ac-article-grid">
          <div className="ac-article-text">
            <h2 className="ac-article-heading">Your Trusted Partner for All AC Installation Needs in Surat</h2>

            <p>
              <a className="ac-link" href="#">Jay Ambe AC Service</a> we understand the importance of a comfortable indoor environment, especially during the sweltering summer months in Surat. With our comprehensive range of  <a className="ac-link" href="#">air conditioning installation</a>,
             services, we are dedicated to ensuring that you and your family enjoy optimal cooling efficiency in your home or office.
            </p>

            <p>
             Our team of highly skilled technicians specializes in installing all types of air conditioning systems, including split units, window ACs, central air conditioning systems, and more. We pride ourselves on delivering exceptional service tailored to meet the unique needs of each customer. Whether you’re upgrading an old system or installing a new one from scratch, we guide you through every step of the process.
            </p>

            <p>
            What sets Jay AMbe AC Service apart is our commitment to quality and professionalism. From initial consultation and site assessment to final installation and testing, our experts handle every aspect with precision. We ensure that your new AC unit is installed according to manufacturer specifications for optimal performance and longevity. Our attention to detail guarantees not only efficient cooling but also energy savings on your electricity bills.
            </p>

            <p>
        In addition to installation services, we offer expert advice on choosing the right type of air conditioner based on your space requirements and budget. Our knowledgeable staff can recommend energy-efficient models that will keep you cool without breaking the bank.
            </p>

            <p>
           Customer satisfaction is at the heart of what we do at Krishna AC Service. Our competitive pricing combined with top-notch service ensures that you receive excellent value for your investment. Don’t let the heat get you down—contact us today for reliable AC installation services in Surat! Experience comfort like never before with Krishna AC Service by your side!
            </p>

          </div>

          <div className="ac-article-image-wrap">
            <img
              className="ac-article-image"
              src={require("../assets/Acinstallation.jpg")}
              alt="AC service"
            />
          </div>
        </div>
      </section>
 <Herolast  />
      <Footer  />
     
    </>
  );
}
